import React from 'react';

const CLASS_LABEL = { '': 'ROOKIE', zero: 'ROOKIE', some: 'DRIVER', vet: 'VETERAN' };

function formatBirthday(dobString) {
  if (!dobString) return '—';
  const d = new Date(dobString);
  if (isNaN(d)) return dobString;
  return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
}

function calcAge(dobString) {
  if (!dobString) return null;
  const dob = new Date(dobString);
  if (isNaN(dob)) return null;
  const today = new Date();
  let age = today.getFullYear() - dob.getFullYear();
  const m = today.getMonth() - dob.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) age--;
  return age;
}

function ViewUserModal({ user, onClose }) {
  const age = calcAge(user.birthday);

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      background: 'rgba(0,0,0,0.75)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      padding: '16px',
    }}>
      <div className="card animate-in" style={{ width: '100%', maxWidth: 480, margin: 'auto', maxHeight: '90vh', overflowY: 'auto' }}>

        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
          <h2 className="font-heading" style={{ fontSize: 20 }}>Driver Details</h2>
          <button
            onClick={onClose}
            style={{ background: 'none', border: 'none', color: 'var(--text-muted)', cursor: 'pointer', fontSize: 20, lineHeight: 1 }}
          >✕</button>
        </div>

        {/* Avatar + Name */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 24 }}>
          <div style={{
            width: 64, height: 64, borderRadius: '50%',
            background: 'var(--accent-gradient)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontFamily: 'JetBrains Mono, monospace', fontWeight: 700, fontSize: 26, color: '#fff', flexShrink: 0,
          }}>
            {(user.name || '?')[0].toUpperCase()}
          </div>
          <div>
            <div className="font-heading" style={{ fontSize: 20 }}>{user.name || '—'}</div>
            <div style={{ color: 'var(--text-muted)', fontSize: 13 }}>{user.id}</div>
          </div>
        </div>

        {/* Fields */}
        {[
          { label: 'Serial No.',    value: user.id },
          { label: 'Callsign',      value: user.callsign },
          { label: 'Email',         value: user.email },
          { label: 'Date of Birth', value: user.birthday
              ? `${formatBirthday(user.birthday)}${age !== null ? `  (Age: ${age})` : ''}`
              : '—'
          },
          { label: 'Driver Class',  value: CLASS_LABEL[user.driverClass] || 'ROOKIE' },
          { label: 'Status',        value: user.status, isStatus: true },
          { label: 'Joined',        value: user.joined },
        ].map(row => (
          <div key={row.label} style={{
            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
            padding: '12px 0', borderBottom: '1px solid var(--border)',
          }}>
            <span style={{
              fontSize: 12, color: 'var(--text-muted)',
              textTransform: 'uppercase', letterSpacing: 1, fontWeight: 600,
            }}>
              {row.label}
            </span>
            <span style={{ color: 'var(--text-primary)', fontWeight: 500, textAlign: 'right' }}>
              {row.isStatus ? (
                <span className={`badge ${
                  user.status === 'Active'     ? 'badge-success' :
                  user.status === 'Blocked'    ? 'badge-warning' : 'badge-danger'
                }`}>
                  {user.status}
                </span>
              ) : row.value}
            </span>
          </div>
        ))}

        {/* Close */}
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20 }}>
          <button className="btn-secondary" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}

export default ViewUserModal;